const COUPON_INTEGRATION = {
    NONE                         : 'NONE',
    SEARCH_MANDATORY             : 'SEARCH_MANDATORY',
    CHECKOUT_OPTIONAL            : 'CHECKOUT_OPTIONAL',
    SEARCH_AND_CHECKOUT_OPTIONAL : 'SEARCH_AND_CHECKOUT_OPTIONAL',
};

export default COUPON_INTEGRATION;
